import MAYA from '../../../maya_api'
import _ from 'lodash'
// ------------------------------------
// Constants
// ------------------------------------
const SEARCH_BILLERS = 'SEARCH_BILLERS';
const LOAD_FAVOURITES_BILLERS = 'LOAD_FAVOURITES_BILLERS';
const CHANGE_POBOX = 'CHANGE_POBOX';
const CHANGE_ZIP = 'CHANGE_ZIP';
const CHANGE_BILLER_NAME = 'CHANGE_BILLER_NAME';
const SET_BILLER_LOADING = 'SET_BILLER_LOADING';
const MARK_SEARCH_STARTED = 'SEARCH_STARTED';

// ------------------------------------
// Actions
// ------------------------------------
function doBillersSearch(biller_po_box = '', biller_zip = '', biller_name = '') {
  return (dispatch, getStore) => {
    dispatch(setBillersLoading(true));

    MAYA.doBillerSearch({biller_po_box, biller_zip, search_word: biller_name}).then((result) => {
      dispatch(setBillersLoading(false));

      dispatch({
        type: SEARCH_BILLERS,
        payload: result
      });
    })
  }
}

function loadFavoritesBillers() {
  return (dispatch) => {
    MAYA.getFavoritesBillers().then((result) => {
      dispatch({
        type: LOAD_FAVOURITES_BILLERS,
        payload: result
      });
    })
  };
}

function setBillersLoading(value = false) {
  return {
    type: SET_BILLER_LOADING,
    payload: value
  }
}

function changePobox(value = '') {
  return {
    type: CHANGE_POBOX,
    payload: value
  }
}

function changeZip(value = '') {
  return {
    type: CHANGE_ZIP,
    payload: value
  }
}

function changeBillerName(value = '') {
  return {
    type: CHANGE_BILLER_NAME,
    payload: value
  }
}

function markSearchStarted() {
  return {
    type: MARK_SEARCH_STARTED
  }
}

export {
  loadFavoritesBillers,
  doBillersSearch,
  changePobox,
  changeZip,
  changeBillerName,
  markSearchStarted
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SEARCH_BILLERS]: (state, action) => ({
    ...state,
    searchResult: action.payload,
    searchStarted: true
  }),
  [LOAD_FAVOURITES_BILLERS]: (state, action) => ({
    ...state,
    favorites: action.payload
  }),
  [CHANGE_POBOX]: (state, action) => ({
    ...state,
    billerPOBox: action.payload
  }),
  [CHANGE_ZIP]: (state, action) => ({
    ...state,
    billerZip: action.payload
  }),
  [CHANGE_BILLER_NAME]: (state, action) => ({
    ...state,
    billerName: action.payload
  }),
  [SET_BILLER_LOADING]: (state, action) => ({
    ...state,
    billerLoading: action.payload
  }),
  [MARK_SEARCH_STARTED]: (state, action) => ({
    ...state,
    searchStarted: true
  })
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  searchResult: [],
  favorites: [],
  billerPOBox: '',
  billerZip: '',
  billerName: '',
  billerLoading: false,
  searchStarted: false
};

export default function billersReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/components/Billers/modules/billers.js